import { useTheme } from 'react-native-paper'
import { Container } from './Container'
import { TextInput } from 'react-native'
import { IconSearch } from '../../assets/icons'
import React from 'react'
import { helpers } from '@linqpal/common-frontend'

const { composeStyle, webSpecificStyle } = helpers

export const SearchBarWithIcon = ({ value, onChangeText, style, ...props }) => {
  const {
    colors: { borderLight, accentText, primary },
    fonts: {
      medium
    }
  } = useTheme()

  return (
    <Container minified style={{
      flex: 1,
      height: 40,
      borderRadius: 60,
      borderWidth: 1,
      borderColor: borderLight,
      flexDirection: 'row',
      alignItems: 'center',
      ...style
    }} {...props}>
      <TextInput
        name={'search'}
        style={composeStyle(
          {
            flex: 1,
            color: primary,
            ...medium
          },
          webSpecificStyle({
            outline: 'none',
            caretColor: accentText,
          })
        )}
        onChangeText={onChangeText}
        value={value}
      />
      <Container center style={{
        position: 'absolute',
        right: 7,
        height: 37,
        justifyContent: 'center'
      }}>
        <IconSearch height={28} width={28}/>
      </Container>
    </Container>
  )
}
